var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-pull-refresh',{attrs:{"pulling-text":_vm.pullingText,"loosing-text":_vm.loosingText,"success-text":_vm.successText,"loading-text":_vm.loadingText},on:{"refresh":_vm.onRefresh},model:{value:(_vm.refreshing),callback:function ($$v) {_vm.refreshing=$$v},expression:"refreshing"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }